import React, { useEffect, useRef, useState } from 'react';

import './style.scss'
import { SEOHeader } from 'views/components';
import * as Yup from 'yup';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { showTostify } from 'utils/interfaces';
import { routes } from 'utils/routes';
import statesData from 'static.json'
import CustomToast from 'views/components/form-inputs/alert';
import { InputField, RadioButton, SelectField } from 'views/components/form-inputs';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { quicklinkService } from 'services';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { parseISO } from 'date-fns';
import moment from 'moment';

const initialValue = {
  title: "",
  description: "",
  brand_name: "",
  regular_price: "",
  offer_price: "",
  type: "global",
  valid_till: "",
  state: "",
  city: "",
};

const AddQuicklinks = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const toastRef = useRef<any>(null);
  const navigation = useNavigate()
  const params = useParams()
  const id: any = params.id
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [initialData, setInitialData] = useState({ ...initialValue, type: type || "global" });

  const formik: any = useFormik({
    initialValues: initialData,
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: Yup.string().required('Title is required'),
      description: Yup.string().required('Description is required'),
      brand_name: Yup.string().required('Brand Name is required'),
      regular_price: Yup.string().required('Regular Price is required'),
      offer_price: Yup.string().required('Offer Price is required'),
      type: Yup.string().required('Type is required'),
      valid_till: Yup.string().required('Valid till is required'),
      city: Yup.string().required('City is required'),
      state: Yup.string().required('State is required'),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        if (id) {
          delete values.id
          delete values.created_by
          delete values.created_at
          delete values.updated_at
          const data = await quicklinkService.updateQuicklink(id, values);
          if (data.error === false) {
            showTostify(toastRef, 'success', data.message);
            setTimeout(() => {
              navigation(`${routes.quicklinks}?type=${type}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
        else {
          const data = await quicklinkService.createQuicklink(values);
          if (data.error === false) {
            showTostify(toastRef, 'success', data.message);
            formik.resetForm();
            setTimeout(() => {
              navigation(`${routes.quicklinks}?type=${type}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message);
      } finally {
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    if (id) {
      const fetchQuicklinkDetails = async () => {
        const data = await quicklinkService.getQuicklinkDetails(id);
        console.log('data', data);

        if (!data.error) {
          setInitialData(data)
          const selectedState: any = statesData.states.find(state => state.short_label === data.state);
          if (selectedState) {
            setCities(selectedState.cities);
          } else {
            setCities([]);
          }
        } else {
          showTostify(toastRef, 'error', data.message);
        }
      };
      fetchQuicklinkDetails();
    }
  }, [id]);

  const handleStateChange = (e: any) => {
    const selectedStateId = e.value;
    formik.setFieldValue('state', selectedStateId);
    const selectedState: any = statesData.states.find(state => state.short_label === selectedStateId);
    if (selectedState) {
      setCities(selectedState.cities);
      formik.setFieldValue('city', '');
    } else {
      setCities([]);
    }
  };

  return (
    <>
      {/* <CustomToast ref={toastRef} /> */}
      <SEOHeader title="Create Quicklinks" />
      <div className="quicklinks-page">
        <div className="container">
          <div className='bg-white border-round-2xl w-75'>

            <form onSubmit={formik.handleSubmit} >
              <CustomToast ref={toastRef} />

              <div className="p-4 border-bottom-1 border-primary-color">
                <h2 className='text-start m-0'>{id ? "Edit Quicklink" : "Add New Quicklink"}</h2>
              </div>
              <div className="grid m-0 py-4 p-3">
                <div className="grid m-0">

                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="title"
                      label="Title"
                      required={true}
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik?.touched.title && formik.errors.title}
                    />
                  </div>
                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="brand_name"
                      label="Brand Name"
                      required={true}
                      value={formik.values.brand_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik?.touched.brand_name && formik.errors.brand_name}
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="regular_price"
                      label="Regular Price"
                      required={true}
                      type="number"
                      value={formik.values.regular_price}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik?.touched.regular_price && formik.errors.regular_price}
                    />
                  </div>
                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="offer_price"
                      label="Offer Price"
                      required={true}
                      type="number"
                      value={formik.values.offer_price}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik?.touched.offer_price && formik.errors.offer_price}
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <div>
                      <RadioButton
                        className="custom-form-check"
                        name="type"
                        value={formik.values.type}
                        onChange={(e: any) => formik.setFieldValue('type', e.value)}
                        options={[
                          { label: 'Global', value: 'global' },
                          { label: 'Local', value: 'local' },
                        ]}
                        required={true}
                        label="Type"
                        error={formik.touched.type && formik.errors.type}
                      />
                    </div>
                  </div>
                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="valid_till">Valid Till<span className='required-field'>*</span></label>
                      <Calendar
                        id="valid_till"
                        name="valid_till"
                        value={formik.values.valid_till ? parseISO(formik.values.valid_till) : null}
                        onChange={(e) => {
                          if (e.value) {
                            const formattedDate = moment(e.value).toISOString();
                            formik.setFieldValue('valid_till', formattedDate);
                          } else {
                            formik.setFieldValue('valid_till', null);
                          }
                        }}
                        showIcon
                        minDate={new Date()}
                        placeholder="Enter here"
                        className={formik.touched?.valid_till && formik.errors?.valid_till ? 'p-invalid' : ''}
                      />
                      {formik.touched?.valid_till && formik.errors?.valid_till && (
                        <Message severity="error" text={formik.errors.valid_till} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <SelectField
                      name="state"
                      showClear
                      label="State"
                      value={formik.values.state}
                      onChange={handleStateChange}
                      options={statesData?.states?.map(state => ({ label: state.label, value: state.short_label }))}
                      error={formik.touched.state && formik.errors.state}
                      required={true}
                      className="my-custom-class"
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <SelectField
                      name="city"
                      showClear
                      label="City"
                      value={formik.values.city}
                      onChange={(e) => formik.setFieldValue('city', e.value)}
                      options={cities.map(city => ({ label: city, value: city }))}
                      error={formik.touched.city && formik.errors.city}
                      required={true}
                      className="w-full"
                      disabled={cities.length === 0}
                    />
                  </div>

                  <div className="col-12">
                    <div className="form-group mb-2">
                      <label htmlFor="description">Description <span className="required-field">*</span></label>
                      <InputTextarea
                        placeholder="Enter here"
                        rows={3}
                        className='w-full'
                        name="description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik?.touched.description && formik.errors.description && <Message severity="error" text={formik.errors.description} />}
                    </div>
                  </div>

                  <div className="col-12 text-center">
                    <Button
                      label={id ? "Edit Quicklinks" : "Add Quicklinks"}
                      type="submit"
                      className="primary"
                      loading={loading}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </>
  );
};

export default AddQuicklinks;
